export default __webpack_public_path__ + "static/media/fetured-item-6.30da623d.png";